import { Box, Stack, styled, Typography, TypographyProps } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { HEADER_TEXT_COLOR } from '../../styles/color';

import dynamic from 'next/dynamic';

const Slider = dynamic(() => import('react-slick'), { ssr: true });

export const HeroSliderCardStyled = styled(Card)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const CardContentWrapper = styled(CardContent)(({ theme }) => ({
  background: HEADER_TEXT_COLOR,
  flex: '1 0 auto',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: ' 0 50px',
  rowGap: '32px',
  alignSelf: 'stretch',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    minWidth: '353px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '24px 0',
    paddingBottom: '60px!important',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '10px 10px 40px 20px',
  },
}));

export const HomePageCardContentWrapper = styled(Stack)(({ theme }) => ({
  display: 'table',
  flexDirection: 'column',
  alignSelf: 'stretch',
  flex: 1,
}));

export const SliderContent = styled(CardContent)(({ theme }) => ({}));

export const StyledSlider = styled(Slider)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  height: '100%',
  '& .slick-list': {
    height: '100%',
  },
  '& .slick-track': {
    height: '100%',
  },
  '& .slick-slide>div': {
    height: '100%',
  },
}));

export const StyledTitle = styled(Typography)<TypographyProps>(({ theme }) => ({
  textDecoration: 'underline',
  textDecorationThickness: '2px',
  textUnderlineOffset: '8px',
}));
// export const StyledTitle = styled((props) => <Typography {...props} />)(({ theme }) => ({
//   textDecoration: 'underline',
//   textDecorationThickness: '2px',
//   textUnderlineOffset: '8px',
// }));

export const StyledReverseItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const CardContentWrapperWithGradient = styled(CardContent)(({ theme }) => ({
  background: `linear-gradient(90deg,#13161b, #010102 )`,
  flex: '1 0 auto',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: ' 0 40px 0 40px',
  rowGap: '32px',
  alignSelf: 'stretch',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    minWidth: '353px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '24px 0',
    paddingBottom: '60px!important',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '10px 10px 40px 20px',
  },
}));
